// extracted by css-extract-rspack-plugin
export default {"BaseCell":"repo-searcher-module__BaseCell__wGuv8","Box":"repo-searcher-module__Box__YjLW2","renderedInput":"repo-searcher-module__renderedInput__kaUeb"};